module.exports = "/desktop-app/assets/img/success.svg?91e3fff8defabce1dceabfbff38b5bd6";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/success.svg
// module id = Ma65
// module chunks = 1